module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGcedc9cad2b62f890f3613a4d994e8643.cedc9cad.png";